
    import Vue from "vue";

    const END_POINT = "/staff";

    const getStaff = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStaff = data => Vue.axios.get(END_POINT, {params: data});

    const createStaff = staff => Vue.axios.post(END_POINT,  staff );

    const createAllStaff = Staff => Vue.axios.post(END_POINT + "/all",  Staff );

    const updateStaff = staff => Vue.axios.put(END_POINT  + "/" + staff.id,  staff );

    const deleteStaff = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStaff,
      getAllStaff,
      createStaff,
      createAllStaff,
      updateStaff,
      deleteStaff
    };
    